/**
 * 通知类型枚举，全集
 *
 * FIXME 增加枚举类型后，若该通知类型会在通知列表显示，需要在{@link NotificationSubType}中将它添加对应的子类型
 * @see Anymate-api/app/Enums/NotificationType.php
 */
export enum NotificationTypeEnum {
  MomentCommented = 4, // 回复动态
  MomentReplied = 5, // 回复评论
  MomentReacted = 6, // 动态回应表情
  TextImageFinished = 7, // 图片生成任务完成
  MomentCommitRequested = 8, // 审阅
  NewChatMessage = 9, // 聊天消息
  NewFollower = 10, // 新关注
  NewAdmirer = 11, // 新守护
  MomentCommitReviewed = 12, // 审阅完成
  StoryGenerated = 13, // 故事生成完成
  ReplyMentionedMateInMoment = 14, // 回复中提到
  VideoCreated = 15, // 视频生成完成
  MomentMentionedMate = 16, // 动态中提到
  MateAdmireRequested = 17, // 想要守护你
  MateAdmireReviewed = 18, // 守护被反馈
  TipReceived = 19, // 收到打赏信息
  CoinVote = 20, // 获得推荐票
  ReviewerPetition = 21, // 资深读者申请通过
  CollectionParticipantAdded = 22, // 收到邀请合集通知
  SuperAdmireReviewed = 23, // 超级守护结果
  MediaPurchased = 24, // Media被支付通知
  MateAdmireSubscribed = 25, // 被高级订阅通知
  TextImageCommented = 26, // TextImage评论
  TextImageReplied = 27, // TextImage评论被回复
  TextImageReacted = 28, // TextImage点赞
  ReplyMentionedMateInTextImage = 29, // TextImage回复@某个角色
  ChatMessageEarned = 30, // 聊天消息收益
  DispatchMissionReturn = 32, // 外派任务待迎接
  WishCompleted = 33, // 许愿池任务完成
  MateAdopted = 34, // 角色被领养
  NewSiteMessage = 35, // 新站内信
  UserShareReward = 36, // 用户分享活动奖励
  MateMail = 37, // 角色邮件
  MateInvitation = 38, // 角色邀请
  SpriteGenerated = 39, // 角色形象生成完成
  HouseEventGenerated = 40, // 事件生成
  MateGenerated = 41, // 角色生成完成
  MemberSubscriptionReceived = 42, // 会员订阅奖励
  UserTaskCompleted = 43, // 用户任务完成
}

// 通知子类型
export const NotificationSubType: {
  [x: string]: {
    label: string;
    types: NotificationTypeEnum[];
  };
} = {
  // 评论和@
  replyOrMention: {
    label: "Notifications.subType.comment",
    types: [
      NotificationTypeEnum.MomentCommented,
      NotificationTypeEnum.ReplyMentionedMateInMoment,
      NotificationTypeEnum.ReplyMentionedMateInTextImage,
      NotificationTypeEnum.MomentMentionedMate,
      NotificationTypeEnum.MomentReplied,
      NotificationTypeEnum.TextImageReplied,
    ],
  },
  // 点赞
  reaction: {
    label: "Notifications.subType.reaction",
    types: [
      NotificationTypeEnum.MomentReacted,
      NotificationTypeEnum.TextImageReacted,
    ],
  },
  // 关注
  // follow: {
  //   label: "Notifications.subType.follow",
  //   types: [NotificationTypeEnum.NewFollower],
  // },
  // 共创
  admire: {
    label: "Notifications.subType.admire",
    types: [
      NotificationTypeEnum.NewAdmirer,
      NotificationTypeEnum.MateAdmireRequested,
      NotificationTypeEnum.MateAdmireReviewed,
      NotificationTypeEnum.MateAdmireSubscribed,
      NotificationTypeEnum.MomentCommitReviewed,
      NotificationTypeEnum.CollectionParticipantAdded,
    ],
  },
  // 系统
  // system: {
  //   label: "Notifications.subType.system",
  //   types: [
  //     NotificationTypeEnum.ReviewerPetition,
  //     NotificationTypeEnum.SuperAdmireReviewed,
  //   ],
  // },
  // 收入
  // income: {
  //   label: "Notifications.subType.income",
  //   types: [
  //     NotificationTypeEnum.MediaPurchased,
  //     NotificationTypeEnum.TipReceived,
  //   ],
  // },
  // 投票
  // vote: {
  //   label: "Notifications.subType.vote",
  //   types: [NotificationTypeEnum.CoinVote],
  // },
};

// 在通知列表中展示的通知类型
export const NotificationListTypes: NotificationTypeEnum[] = Object.values(
  NotificationSubType
)
  .map((item) => item.types)
  .reduce((prev, cur) => prev.concat(cur), []);
